import { agentApi } from "./index";

export interface ConditionsListParams {
  ids?: Array<string>;
  companyId?: string;
  title?: string;
  percent?: boolean;
  offset?: number;
  limit?: number;
  sort?: "title" | "createdAt" | "updatedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: ConditionsListParams, options?: any) => {
  return agentApi.Condition.listCondition(
    params.ids,
    params.companyId,
    params.title,
    params.percent,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    options
  );
};
